<template>
  <div>
    <div class="content-header case-search-header">
      <div class="content-header-left">
        <div class="filters-row">
          <div class="con-select d-flex">
            <div class="selection_search  ml-0"> <!--casetype-->
              <div class="search">
                <div class="vs-component vs-con-input-label vs-input is-label-placeholder vs-input-primary">
                  <div class="vs-con-input">
                    <vs-input :key="'searchtxt'" icon-pack="feather" icon="icon-search" :placeholder="'Employee Name/ID'"
                      class="is-label-placeholder" v-model.lazy="searchtxt" />
                  </div>
                </div>
              </div>
            </div>
            <vs-checkbox id="activeEmp" @input="changeActiveType(activeEmp)" class="ml-2 xs-hidden active-emp-lbl" name="activeEmp"
              v-model="activeEmp">Active Employees
            </vs-checkbox>
          </div>

        </div>
      </div>
      
      <div class="content-header-right">
        <!--filter dropdown-->
        <vs-inv-dropdown >
            <div class="filters-content">
            <div class="filters-form-fileds noscroll">
              <div class="form-container ">
                <div class="vx-row">
                  <!-- <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Hire Date Range</label>
                    <date-range-picker :maxDate="new Date()" :autoApply="autoApply" :ranges="false" :opens="'left'"
                      v-model="hiredOnRange"></date-range-picker>
                  </div> -->
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Reverification Due Date Range</label>
                    <date-range-picker  :autoApply="autoApply" :ranges="false" :opens="'left'"
                      v-model="expirationDateRange"></date-range-picker>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Days until expiration</label>
                    <multiselect
                      v-model="expirationDays"
                      :options="expirationDaysOptions"
                      :multiple="false" :hideSelected="true"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Days"
                      :preselect-first="false"
                    >
                      <!-- <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span
                          class="multiselect__single"
                          v-if="values.length &amp;&amp; !isOpen"
                        >{{ values.length }} options selected</span>
                      </template> -->
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Status Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Status</label>
                    <multiselect
                      v-model="selectedStatus"
                      :options="statusOptions"
                      :multiple="false" :hideSelected="true"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Status"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                      <!-- <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span
                          class="multiselect__single"
                          v-if="values.length &amp;&amp; !isOpen"
                        >{{ values.length }} options selected</span>
                      </template> -->
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Status Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>
                </div>
              </div>
            </div>
            <div class="filters-status">
              <div class="left-buttons"></div>
              <div class="right-buttons">
                <vs-button color="success" class="save" type="filled" v-on:click="set_filter()">Apply</vs-button>
                <vs-button color="dark" class="cancel" type="filled" v-on:click="clear_filter($event)">Clear</vs-button>
              </div>
            </div>
          </div>
          <!-- </vs-dropdown-menu> -->
        <!-- </vs-dropdown> -->
      </vs-inv-dropdown>
        <div class="Generate_buttons" @click="getExportList()">
          <button class="copy_link" v-bind:disabled="exportList">
            <img src="@/assets/images/main/share.png" />
            <small>Export</small>
          </button>
        </div>
      </div>
    </div>
    <NoDataFound ref="NoDataFoundRef" :loading="isListloading" v-if="workAuthList.length == 0" content=""
      :heading="callFromSearch ? 'No Results Found' : 'No Cases Found'" type='petitions' />
    <div class="accordian-table paf_table" v-if="workAuthList.length > 0">

        <vs-table :data="workAuthList" :no-data-text="'No data found...!'">
            <template slot="thead">
                <vs-th>
                    <div class="d-flex">
                        <vs-checkbox
                            @change="selectAllforArchive()" :name="'selecteAll'" v-model="selectedAllForArchive" class="">
                        </vs-checkbox>
                        Employee Name
                    </div>
                </vs-th>
                <vs-th>
                    <div>
                        Employee ID
                    </div>
                </vs-th>
                <vs-th>
                  <div class="vs-table-text">
                    <a @click="sortMe('hiredOn')"
                      v-bind:class="{ 'sort_ascending': sortKeys['hiredOn'] == 1, 
                      'sort_descending': sortKeys['hiredOn'] != 1 }">
                      Date of Hire 
                    </a>
                  </div>
                </vs-th>
                <vs-th>
                  <div class="vs-table-text">
                    <a @click="sortMe('listAExpDate')"
                      v-bind:class="{ 'sort_ascending': sortKeys['listAExpDate'] == 1, 
                      'sort_descending': sortKeys['listAExpDate'] != 1 }">
                      List A Expiration Date</a>
                  </div>
                </vs-th>
                <vs-th>
                  <div class="vs-table-text">
                    <a @click="sortMe('listCExpDate')"
                      v-bind:class="{ 'sort_ascending': sortKeys['listCExpDate'] == 1, 
                      'sort_descending': sortKeys['listCExpDate'] != 1 }">
                      List C Expiration Date</a>
                  </div>
                </vs-th>
                <vs-th>
                  <div class="vs-table-text">
                    <a @click="sortMe('reverifyDueDate')"
                      v-bind:class="{ 'sort_ascending': sortKeys['reverifyDueDate'] == 1, 'sort_descending': sortKeys['reverifyDueDate'] != 1 }">
                      Reverification Due Date</a>
                  </div>
                </vs-th>
                <vs-th>
                  <div class="vs-table-text">
                    <a @click="sortMe('daysExpiration')"
                      v-bind:class="{ 'sort_ascending': sortKeys['daysExpiration'] == 1, 'sort_descending': sortKeys['daysExpiration'] != 1 }">
                      Days Until Expiration</a>
                  </div>
                </vs-th>
                <vs-th>
                  <div class="vs-table-text">
                      Status
                  </div>
                </vs-th>
            </template>
            <template slot-scope="{ data }">
                <vs-tr :data="petition" :key="index" v-for="(petition, index) in data">
                        <vs-td class="td vs-table--td colone d-flex" v-if="true">
                            <vs-checkbox
                                @change="selectForArchive(petition)" :name="'selected_' + petition.index"
                                v-model="petition.selectedForArchive" class="">
                            </vs-checkbox>
                        <span class="pointer">
                                <template v-if="checkProperty(petition, 'employeeName')">
                                {{ checkProperty(petition, 'employeeName') | CapSubString }}
                                </template>
                                <template v-else>
                                -
                                </template>
                            </span>
                        </vs-td>
                        <vs-td class="td vs-table--td coltwo" v-if="true">
                        <span>
                            <span class="pointer"
                            > {{ checkProperty(petition, 'employeeId') ? checkProperty(petition, 'employeeId') : '-' }} </span>
                        </span>
                        </vs-td>
                        <vs-td class="td vs-table--td">
                            <span class="pointer">
                                <template v-if="checkProperty(petition, 'hiredOn')">
                                {{ checkProperty(petition, 'hiredOn') | formatDateUtc }}
                                </template>
                                <template v-else>
                                -
                                </template>
                            </span>
                        </vs-td>
                        <vs-td class="td vs-table--td" v-if="checkProperty(petition, 'empAuthDocs')">
                            <span class="pointer">
                                <template v-if="checkProperty(petition, 'empAuthDocs','category') && checkProperty(petition, 'empAuthDocs','category') === 'List_A'">
                                    <template v-if="checkProperty(petition.empAuthDocs, 'reviewDocs','length') > 0">
                                    {{ petition.empAuthDocs.reviewDocs[0].expiryDate | formatDateUtc }}
                                    </template>
                                    <template v-else>
                                        {{ '-' }}
                                    </template>
                                </template>
                                <template v-else>
                                    {{ '-' }}
                                </template>
                            </span>
                        </vs-td>
                        <vs-td class="td vs-table--td" v-if="checkProperty(petition, 'empAuthDocs')">
                        <span class="pointer">
                            <template v-if="checkProperty(petition, 'empAuthDocs','category') && checkProperty(petition, 'empAuthDocs','category') === 'List_C'">
                                <template v-if="checkProperty(petition.empAuthDocs, 'reviewDocs','length') > 0">
                                {{ petition.empAuthDocs.reviewDocs[0].expiryDate | formatDateUtc }}
                                </template>
                                <template v-else>
                                    {{ '-' }}
                                </template>
                            </template>
                            <template v-else>
                                {{ '-' }}
                            </template>
                            </span>
                        </vs-td>
                        <vs-td class="td vs-table--td">
                            <span class="pointer">
                                <template v-if="checkProperty(petition, 'reverifyDueDate')">
                                {{ checkProperty(petition, 'reverifyDueDate') | formatDateUtc }}
                                </template>
                                <template v-else>
                                {{ '-' }}
                                </template>
                            </span>
                        </vs-td>
                        <vs-td class="td vs-table--td">
                            <span class="pointer">
                                {{ checkProperty(petition, 'DaysExpiration') !== null && checkProperty(petition, 'DaysExpiration') !== undefined
                                    ? checkProperty(petition, 'DaysExpiration')
                                    : '-' }}
                            </span>
                        </vs-td>
                        <vs-td class="td vs-table--td">
                            <span class="statusspan cursor-pointer" v-bind:class="{
                            ' status_created ': checkProperty(petition, 'statusDetails', 'name') == 'Active',
                            ' status_denied ': checkProperty(petition, 'statusDetails', 'name') == 'Terminated'
                            }">{{ (checkProperty(petition, 'statusDetails') && checkProperty(petition, 'statusDetails', 'name')) ? checkProperty(petition, 'statusDetails', 'name') : '-' }}</span>
                        </vs-td>
                </vs-tr>
            </template>
        </vs-table>
     
      <div class="table_footer">
        <div class="vx-col  con-select pages_select" v-if="workAuthList.length > 0">
          <label class="typo__label">Per Page</label>
          <multiselect @input="changeperPage()" v-model="perpage" :options="perPeges" :multiple="false" :allow-empty="false"
            :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Per Page"
            :preselect-first="true">

          </multiselect>
          <span class="totla_list_count" v-if="totalCount"> Total <em>{{totalCount}}</em></span>
        </div>
        <paginate v-if="workAuthList.length > 0" v-model="page" :page-count="totalpages" :page-range="3"
          :margin-pages="2" :click-handler="pageNate"
          prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
          next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" :prev-text="'<i></i>'"
          :next-text="'<i></i>'" :container-class="'pagination vs-pagination--nav'" :page-class="'page-item'">
        </paginate>
      </div>
    </div>
    
  </div>
</template>
<script>
import vsInvDropdown from "@/views/vs-inv-dropdown.vue";
import Paginate from "vuejs-paginate";
import moment from 'moment'
import _ from "lodash";
import Vue from 'vue'
import NoDataFound from "@/views/common/noData.vue";
import Multiselect from "vue-multiselect-inv";
import DateRangePicker from "vue2-daterange-picker";
import Datepicker from "vuejs-datepicker-inv";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
export default {
  provide() {
    return {
      parentValidator: this.$validator,
    };
  },
  watch: {
    searchtxt: function (value) {
      // let text = value.trim();

      // if (text.length > 3 || text == '') {
      //   this.getWorkAuthList(true, false);
      // }
      this.searchMe();
    },
  },
  data: function () {
    return {
      selectedAllForArchive:false,
      isActive : false,
      autoApply: "",
      debounce:null,
      exportList: false,
      activeEmp: false,
      exportData: {},
      expirationDays: null,
      expirationDaysOptions: ['with_in_15_days','with_in_30_days','with_in_60_days'],
    //   expirationDaysOptions: [15,30,60],
      selectedStatus: null,
      statusOptions: [
        {id:1,name:'Active'},
        {id:2,name:'Terminated'}
      ],
      workAuthList: [],
      selectedWorkAuthList:[],
      selectedForArchiveList:[],
      selectedCaseItems:[],
      selectedIds:[],
      sortKeys: {},
      sortKey: {},
      page: 1,
      perpage: 25,
      totalpages: 0,
      totalCount:0,
      perPeges: [10, 25, 50, 75, 100, 500],
      callFromSearch: false,
      isListloading: false,
      searchtxt: '',
      encodedString: '',
      // hiredOnRange: null,
      hiredOnRange: ["",""],
      // expirationDateRange: null,
      expirationDateRange: ["",""],
      // retentionDateRange: ["",""],
      // retentionDateRange: null,
    }
  },
  components: {
    vsInvDropdown,
    Multiselect,
    Paginate,
    NoDataFound,
    Datepicker,
    DateRangePicker,
    moment
  },
  methods: {
    selectAllforArchive() {
      this.selectedForArchiveList = [];
      this.selectedWorkAuthList = [];
      _.forEach(this.workAuthList, (item) => {
        item.selectedForArchive = false;
        if (this.selectedAllForArchive) {
          item.selectedForArchive = true;
          this.selectedForArchiveList.push(item._id)
          this.selectedCaseItems.push(item);
          this.selectedWorkAuthList.push(item);

        }

      })
      this.selectedIds = [...this.selectedForArchiveList];

      if (this.workAuthList.length > 0 && this.workAuthList.length != this.selectedForArchiveList.length) {
        this.selectedAllForArchive = false;
      }



    },
    selectForArchive(caseItem) {
          if (this.checkProperty(caseItem, 'selectedForArchive')) {
            if (this.selectedForArchiveList.indexOf(caseItem['_id']) <= -1) {
              this.selectedForArchiveList.push(caseItem['_id'])
              if (!this.selectedWorkAuthList.includes(caseItem)) {
                this.selectedWorkAuthList.push(caseItem);
              }
              if (!this.selectedCaseItems.includes(caseItem)) {
                this.selectedCaseItems.push(caseItem);
              }
            }

          } else {
            this.selectedForArchiveList = _.filter(this.selectedForArchiveList, (item) => {
              return item != caseItem['_id']
            })
            this.selectedCaseItems = _.filter(this.selectedCaseItems, (item) => {
              return item != caseItem
            })
            this.selectedWorkAuthList = _.filter(this.selectedWorkAuthList, (item) => {
              return item !== caseItem;
            })
          }
        this.selectedAllForArchive = false
        if (this.workAuthList.length == this.selectedForArchiveList.length && this.selectedForArchiveList.length > 0) {
          this.selectedAllForArchive = true
        }
        this.selectedIds = [...this.selectedForArchiveList];

    },
    changeActiveType(item){
      if(item){
        this.isActive = true;
        this.selectedStatus = {id:1,name:'Active'};
      }else{
        this.isActive = false;
        this.selectedStatus = null;
      }
      this.getWorkAuthList();
    },
    searchMe(){
        let self =this;
      this.page = 1;
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        self.getWorkAuthList(true, false);
      }, 900)
      },
    getWorkAuthList(callFromSearch = false, callFromFilter = false) {
      this.exportData = {};
      this.callFromSearch = callFromSearch
      if (this.callFromSearch) {
        this.workAuthList = []
      }
      //'623b3c3c75d58329b830cdcd','625e6857cadbc43c50c92ee7','628f6b6b096c8624d886648b'
      // "expirationDateRange": (this.expirationDateRange[0] !== "" || this.expirationDateRange[1] !== "") ? this.expirationDateRange : null,
      let Payload = {
        "matcher": {
                      "searchString": this.searchtxt,
                      "DaysExpiration": this.expirationDays
                  },
        page: this.page,
        perpage: this.perpage,
        sorting: this.sortKey,
        today: moment().format('YYYY-MM-DD'),
      }
          if (this.expirationDateRange.startDate && this.expirationDateRange.endDate) {
            Payload["matcher"]["expirationDateRange"] = [
              moment(this.expirationDateRange.startDate).format("YYYY-MM-DD"),
              moment(this.expirationDateRange.endDate).format("YYYY-MM-DD")
            ];
          }
    //   if(this.expirationDays){
    //     if(this.expirationDays == 15){
    //         Payload['matcher']['DaysExpiration'] = 'with_in_15_days';
    //     }
    //     if(this.expirationDays == 30){
    //         Payload['matcher']['DaysExpiration'] = 'with_in_30_days';
    //     }
    //     if(this.expirationDays == 60){
    //         Payload['matcher']['DaysExpiration'] = 'with_in_60_days';
    //     }
    //   }
      if (this.selectedStatus && this.selectedStatus.hasOwnProperty('name') && this.checkProperty(this.selectedStatus, 'name') == "Active") {
        Payload['matcher']['employeeStatus'] = true
      };
      if (this.selectedStatus && this.selectedStatus.hasOwnProperty('name') && this.checkProperty(this.selectedStatus, 'name') == "Terminated") {
        Payload['matcher']['employeeStatus'] = false
      };
      this.exportData = Payload['matcher'];
      this.isListloading = true;
      this.updateLoading(true);
      let tempObj={
          selectedStatus:this.selectedStatus,
          searchtxt:this.searchtxt,
          page:this.page,
          perpage:this.perpage,
          sortKey:this.sortKey
      };
      this.$store.dispatch("commonAction", { "data": Payload, "path": "/reports/work-auth-date" }).then((response) => {
        this.setQueryString(tempObj)
        this.isListloading = false;
        this.updateLoading(false);
        this.workAuthList = response.list;
        this.totalCount = this.checkProperty(response, 'totalCount')
        this.totalpages = Math.ceil(response.totalCount / this.perpage)
        setTimeout(() => {
          this.updateLoading(false);
        }, 10);
      })
        .catch((err) => {
          this.isListloading = false;
          this.updateLoading(false);
        })
    },
      setQueryString(obj){
        const string = JSON.stringify(obj) // convert Object to a String
        this.encodedString = btoa(string) // Base64 encode the String
        this.$route['query']['filter'] = this.encodedString;
      },
    getExportList() {
      let Payload = {
        matcher: {},
        selectedIds: this.selectedIds,
        reportType: "Work Authorization Expiration Reports",
        page: this.page,
        perpage: this.perpage,
        sorting: this.sortKey,
        today: moment().format('YYYY-MM-DD'),
      };
      Payload['matcher'] = this.exportData;
    //   let Payload = this.exportData;
        this.exportList = true;
      this.$store.dispatch("commonAction", { "data": Payload, "path": "/reports/export-workauth" }).then((response) => {
        this.exportList = false;
        if (this.checkProperty(response, 'path')) {
          window.open(this.$globalgonfig._APIURL + "/common/viewfile?filename=Work_Auth_Expiration_Report.xlsx&path=" + this.checkProperty(response, 'path'), "_blank");
        }
      }).catch((err) => {
        this.exportList = false;
      })
    },
    pageNate(pageNum) {

      this.page = pageNum;
      this.getWorkAuthList();
    },
    changeperPage() {
      this.page = 1;
      localStorage.setItem('petitions_perpage', this.perpage);
      this.getWorkAuthList(true);
    },
    sortMe(sort_key = '') {
      if (sort_key != '') {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1
        this.sortKey = {};
        this.sortKey = { "path": sort_key, "order": this.sortKeys[sort_key] }
        localStorage.setItem('petitions_sort_key', sort_key);
        localStorage.setItem('petitions_sort_value', this.sortKey[sort_key]);
        this.getWorkAuthList();
      }
    },
    set_filter: function () {
      if(this.selectedStatus){
        if(this.selectedStatus.name == 'Active'){
          this.activeEmp = true;
          this.isActive = true;
        }else{
          this.activeEmp = false;
          this.isActive = false;
        }
      }
      this.page =1;
      this.getWorkAuthList();
      document.body.classList.remove('scroll-hidden');
    },
    clear_filter: function () {
      this.searchtxt = '';
      this.expirationDays = null;
      // this.hiredOnRange["startDate"] = "";
      // this.hiredOnRange["endDate"] = "";
      this.expirationDateRange.startDate = "";
      this.expirationDateRange.endDate = "";
      // this.retentionDateRange.startDate = "";
      // this.retentionDateRange.endDate = "";
      if(this.selectedStatus){
        this.selectedStatus = null;
        this.activeEmp = false;
        this.isActive = false;
      }
      this.getWorkAuthList();
      document.body.classList.remove('scroll-hidden');
    },
    petitionlink(tr) {
      let routedId = this.checkProperty(tr, '_id')
      this.$router.push({ path: `/i9-details/${routedId}`, query: { 'filter': this.encodedString } })   
    },
  },
  mounted() {
    this.sortKeys = {
      "caseNo": 1,
      "statusName": 1,
      "createdOn": 1,
      "updatedOn": -1,
      "employeeName": 1,
      "employeeId":1,
      "hiredOn":1,
      "listAExpDate":1,
      "listCExpDate":1,
      "daysExpiration": 1,
      "reverifyDueDate":1
    },
      this.sortKey = { "path": 'updatedOn', "order": -1 };
    if (localStorage.getItem('petitions_sort_key') && localStorage.getItem('petitions_sort_value') && localStorage.getItem('petitions_sort_value') >= -1) {
      this.sortKey = {};
      this.sortKey = { "path": localStorage.getItem('petitions_sort_key'), "order": parseInt(localStorage.getItem('petitions_sort_value')) };
      this.sortKeys[localStorage.getItem('petitions_sort_key')] = parseInt(localStorage.getItem('petitions_sort_value'));
     
    }
    this.getWorkAuthList();
  },
  computed:{}
};
</script>
